import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiRequestService } from "../services/api-request/api-request.service";

@Injectable({
  providedIn: 'root'
})
export class AmaService {

  public inputQuestionJson;
  public sampleDataFromApi = {};


  public sampleQuestion: any;
  public aduienceGender: any;
  public audienceCity: any;
  public audienceAge: any;
  public audienceSec: any;
  public audience: any;
  public choices: any;
  public qTypes: any;
  public currentQuestionId: number;
  public globaluseraskedDataStored={};

  public QuestionInputData: any = {};

  public newQuestion: { 'id'?: number, "question": [{ "Q": string, "T": string, "C": string[] }], "audience": { "age": string[], "gender": string[], "city": string[], "SEC": string[] }, "isFromEagleeye": boolean };


  public userAskedQuestions={};
  public filterData=[];

  public isLoading: boolean = false;
  public isOpen: boolean = false;
  public Difference_In_Days;
  public GET_SAMPLE_DATA = environment.apiUrl + "/ama/get-sample-data";
  public SAVE_QUESTION = environment.apiUrl + "/ama/questions";
  public SAVE_USER = environment.apiUrl + '/ama/user';
  public FETCH_QUESTION = environment.apiUrl + '/ama/userAskedQuestion';
  public FETCH_QUESTION_Details = environment.apiUrl + '/ama/getquestions';

  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params: {}
  };
  constructor(private http: HttpClient, private apiRequest: ApiRequestService) {
    this.newQuestion = { "question": [{ "Q": '', "T": '', "C": [] }], "audience": { "age": [], "gender": [], "city": [], "SEC": ['SEC A', "SEC B"] }, "isFromEagleeye": true };
  }

  qnsJsonSetData(data) {
    this.inputQuestionJson = data;
    console.log(this.inputQuestionJson);
  }

  getSampleData(): Observable<any> {
    return this.apiRequest.request('GET','/ama/get-sample-data');
    // return this.http.get(this.GET_SAMPLE_DATA, this.httpPostOptions);
  }
  postQuestion(data) {
    return this.apiRequest.request('POST','/ama/questions',data);
    // return this.http.post(this.SAVE_QUESTION, data, this.httpPostOptions);
  }
  postUser(data) {
    return this.apiRequest.request('POST','/ama/user',data);
    // return this.http.post(this.SAVE_USER, data, this.httpPostOptions);
  }
  getUserAskedQuestion(): Observable<any> {
    return this.apiRequest.request('POST','/ama/userAskedQuestion');
    // return this.http.post(this.FETCH_QUESTION, {}, this.httpPostOptions);
  }
  getQuestionDetails(question_id): Observable<any> {
    //console.log('QuestionDemo',question_id);
    let pathUrl = '/ama/getquestions/' + question_id
    return this.apiRequest.request('POST',pathUrl);
    // return this.http.post(environment.apiUrl + '/ama/getquestions/' + question_id, {}, this.httpPostOptions);
  }
  saveFinalQuestionsdata(question_id) {
    let body = { "question_id": question_id };
    return this.apiRequest.request('POST','/ama/questionsubmit',body);
    // return this.http.post(environment.apiUrl + '/ama/questionsubmit', body, this.httpPostOptions);
  }

  fetchSampleData() {
    this.getSampleData().subscribe((result) => {
      this.sampleDataFromApi = result;
      //console.log('Hiii', result);
      this.sampleQuestion = this.sampleDataFromApi['data']
      this.audience = this.sampleQuestion.audience;
      this.qTypes = this.sampleQuestion.qProperties[0].options;
      this.choices = [];
      for (let i = 0; i < this.sampleQuestion.qOptions.length; i++) {
        this.choices.push({ "value": this.sampleQuestion.qOptions[i] });
        if (i == this.sampleQuestion.qOptions.length - 1) {
          this.choices.push({ value: "" });
        }
      }
      if (this.choices.length == 0) {
        this.choices.push({ value: "" });
      }
      this.aduienceGender = this.audience[0];
      this.audienceCity = this.audience[1];
      this.audienceAge = this.audience[2];
      this.audienceSec = this.audience[3]

    }, err => {
      console.log("Something went wrong")
    })

  }
  fetchUserAskedQuestion() {
    this.getUserAskedQuestion().subscribe((result) => {
      //console.log('Result', result);
      this.userAskedQuestions = result;
      if (result.data) {
        this.filterData = result.data;
        //console.log('FilterData', this.filterData)
        if (result.data.length > 0) {
          let prevDate = result.data[0].created;
          this.compareDate(prevDate);
        }
      }
      //  // console.log('userAskedQuestions fetched data :: ', this.userAskedQuestions);
      else {
        this.filterData = [];
      }
    }, (err) => {
      console.log(err);
    })
  }
  compareDate(prevDate) {
    let currDate = new Date();
    let prevDate1 = new Date(prevDate);
    let Difference_In_Time = currDate.getTime() - prevDate1.getTime();
    this.Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  }



}
